import basicRequest from "../../../../core/redux/actions/request";

import { notification } from "antd";

const PREFIX_FORM = "BOX_USERS";
export const getBoxUsers = (state) => state.config.box.users;
const {
    isLoading: boxUserLoading,
    isLoaded: boxUserLoad,
    getPattern,
    isSecondaryLoading: boxActionLoading,
    postPattern,
    deletePattern,
} = basicRequest(PREFIX_FORM, getBoxUsers);

export const loadBoxUsers = () => {
    const url = "react/v1/box/users";
    return getPattern(url, {});
};

export const addBoxUser = (userEmail) => postPattern("react/v1/box/user/" + userEmail, {});
export const deleteBoxUser = (colaborationId) => deletePattern("react/v1/box/user/" + colaborationId, {});

export { boxUserLoading, boxUserLoad, boxActionLoading };
